export const OfficeUsersListState = {
	url: '/users',
	title: 'Office List Users',
	template: '<users-page></users-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeUsersListPageMod" */
			'@Containers/office-users-page/office-users-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
